import React, { useState, useEffect } from "react";
import "./ProjectsGallery.css";

export default function ProjectsGallery({ images }) {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openCarousel = (index) => {
    setCurrentIndex(index);
  };

  const closeCarousel = () => {
    setCurrentIndex(null);
  };

  const showPrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const showNext = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKey = (e) => {
      if (currentIndex === null) return;

      if (e.key === "Escape") closeCarousel();
      if (e.key === "ArrowRight") showNext();
      if (e.key === "ArrowLeft") showPrev();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [currentIndex]);

  return (
    <>
      <section className="projects-section">
        

        <div className="projects-grid">
          {images.map((img, index) => (
            <div
              key={index}
              className="project-tile"
              onClick={() => openCarousel(index)}
            >
              <img src={img} alt={`project-${index}`} />
            </div>
          ))}
        </div>
      </section>

      {currentIndex !== null && (
        <div className="carousel-overlay" onClick={closeCarousel}>
          <div
            className="carousel-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="nav prev" onClick={showPrev}>
              &#10094;
            </button>

            <img
              src={images[currentIndex]}
              alt="Expanded view"
            />

            <button className="nav next" onClick={showNext}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </>
  );
}